module.exports = __webpack_public_path__ + "static/media/8.b0e276af.png";